<template>
  <div>
    <div class="p-3 bg-white rounded-xl shadow-lg mx-4">
      <div class="grid grid-cols-2" @click="showFilters = !showFilters">
        <div class="flex items-center gap-4">
          <a-icon type="filter" class="text-lg ml-2"></a-icon>
          <h2 class="text-left text-lg text-gray-600">
            <b>Filtros de búsqueda</b>
          </h2>
        </div>
        <span
          class="h-5 w-5 m-2 flex justify-center items-center transition justify-self-end"
          :class="{ 'transform rotate-180': showFilters }"
        >
          <a-icon type="caret-down" class="text-xl my-auto" />
        </span>
      </div>
      <a-divider v-if="showFilters" class="mt-2 mb-2"></a-divider>
      <div
        class="flex gap-5 flex-wrap relative w-full border-box"
        v-show="showFilters"
      >
        <form id="filterSupportForm" @submit.prevent="submitForm">
          <div
            class="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 relative"
          >
            <!--Entidad emisora de valores -->
            <BaseSelect
              ref="compania_emisor"
              id="compania_emisor"
              label="Entidad emisora de valores"
              :selectOptions="formOptions.optionsCompanyEmisor"
              v-model="form.company_emisores_id"
              :value="form.company_emisores_id"
              :loading="loading"
            />

            <!--Tipo de valor -->
            <BaseSelect
              ref="tipo_valor"
              id="tipo_valor"
              label="Tipo de valor"
              :selectOptions="formOptions.optionsTypeValueEmisor"
              v-model="form.motivo_emisores_id__tipo_valor_id"
              :value="form.motivo_emisores_id__tipo_valor_id"
              :loading="loading"
            />

            <!--Motivo -->
            <BaseSelect
              ref="motivo"
              id="motivo"
              label="Motivo"
              :selectOptions="optionsReasonsEmisor"
              v-model="form.motivo_emisores_id"
              :value="form.motivo_emisores_id"
              :loading="loading"
            />

            <!--Código de quejas -->
            <BaseInput
              type="text"
              label="Código de queja"
              placeholder="Ej: 26598965472981"
              v-model="form.codigo_queja"
            />

            <!--Estado de radicación -->
            <BaseSelect
              ref="estado_radicacion"
              id="estado_radicacion"
              label="Estado de radicación"
              :selectOptions="customStatusSolip"
              v-model="form.estado_solip"
              :value="form.estado_solip"
              :loading="loading"
            />

            <!--Estado de radicación de anexos -->
            <BaseSelect
              ref="estado_radicacion_anexos"
              id="estado_radicacion_anexos"
              label="Estado de radicación de anexos"
              :selectOptions="customStatusSolipAnexes"
              v-model="form.estado_solip_anexes"
              :value="form.estado_solip_anexes"
              :loading="loading"
            />

            <!--Tipo de identificación -->
            <BaseSelect
              ref="tipo_documento"
              id="tipo_documento"
              label="Tipo de identificación"
              :selectOptions="formOptions.optionsIdentificationType"
              v-model="form.tipo_id_CF"
              :value="form.tipo_id_CF"
              :loading="loading"
            />

            <!--Número de identificación -->
            <BaseNumber
              label="No. de identificación"
              placeholder="Ej: 123456789"
              v-model="form.numero_id_CF"
              :doNotValidateNit="true"
            />

            <!-- Fecha de radicacion. -->
            <BaseRangeDate
              ref="fecha_de_radicacion"
              label="Fecha de radicacion"
              :value="
                form.start_date && form.end_date
                  ? [form.start_date, form.end_date]
                  : null
              "
              @notify-dates="setRangeDate($event)"
            />

            <!-- Nombre del apoderado -->
            <BaseInput
              type="text"
              label="Nombre del apoderado"
              placeholder="Ej: Sutano Ramirez"
              v-model="form.apoderado_nombre"
            />

            <!-- Correo del apoderado -->
            <BaseInput
              type="text"
              label="Correo del apoderado"
              placeholder="emailapoderado@example.com"
              v-model="form.apoderado_correo"
            />

            <!-- Nombre completo del CF -->
            <BaseInput
              type="text"
              label="Nombre completo del CF"
              placeholder="Ej: Ander"
              v-model="form.nombres"
            />

            <!--Correo electrónico -->
            <BaseInput
              type="email"
              label="Correo electrónico"
              placeholder="username@example.com"
              v-model="form.email"
            />

            <!--Correo electrónico de notificacion-->
            <BaseInput
              ref="emailNotification"
              type="email"
              label="Correo electrónico de notificación"
              placeholder="emailnotification@example.com"
              v-model="form.email_notification"
            />
          </div>

          <div class="w-full flex justify-end self-end gap-4 mt-5 mb-3">
            <a-button
              class="w-1/2 gap-2 sm:mt-auto mt-3 lg:w-1/6"
              type="danger"
              ghost
              shape="round"
              @click="clearFilters"
            >
              Limpiar
            </a-button>

            <!-- :disabled="disableButton && disabled" -->
            <!-- :loading="(searching = loading)"  -->
            <a-button
              :disabled="searching ? true : false"
              type="primary"
              shape="round"
              @click="submitForm"
              class="w-1/2 gap-2 sm:mt-auto mt-3 lg:w-1/6"
            >
              <a-icon type="search" v-if="!searching"></a-icon>
              {{ searching ? "BUSCANDO..." : "BUSCAR" }}
            </a-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from "@/core/utils/constants";

export default {
  props: ["loading", "searching"],
  data() {
    return {
      form: {
        nombres: "",
        company_emisores_id: "",
        motivo_emisores_id__tipo_valor_id: "",
        motivo_emisores_id: "",
        codigo_queja: "",
        tipo_id_CF: "",
        numero_id_CF: "",
        apoderado_nombre: "",
        apoderado_correo: "",
        email: "",
        email_notification: "",
        start_date: "",
        end_date: "",
        estado_solip: "",
        estado_solip_anexes: "",
        motivo_emisores_id: "",
      },
      optionsReasonsEmisor: [],
      showFilters: false,
    };
  },
  created() {
    this.initializeForm();
  },
  async mounted() {
    let options = await this.$store.dispatch(
      "form/loadAllReasonsEmisorOptions"
    );
    this.optionsReasonsEmisor = [...options];
    const pagination = {};
    this.$emit("getFilterForm", this.form, pagination);
  },
  methods: {
    async submitForm() {
      const pagination = {
        page: DEFAULT_PAGE,
        pageSize: DEFAULT_PAGE_SIZE,
      };

      this.$emit("getFilterForm", this.form, pagination);
    },
    async clearFilters() {
      this.initializeForm();

      const pagination = {
        page: DEFAULT_PAGE,
        pageSize: DEFAULT_PAGE_SIZE,
      };

      this.$emit("getFilterForm", this.form, pagination);
    },
    initializeForm() {
      const startDate = moment().subtract(7, "d").format("YYYY-MM-DD");
      const endDate = moment().format("YYYY-MM-DD");
      this.form = {
        nombres: "",
        company_emisores_id: "",
        motivo_emisores_id__tipo_valor_id: "",
        motivo_emisores_id: "",
        codigo_queja: "",
        tipo_id_CF: "",
        numero_id_CF: "",
        apoderado_nombre: "",
        apoderado_correo: "",
        email: "",
        email_notification: "",
        start_date: startDate,
        end_date: endDate,
        estado_solip: "",
        estado_solip_anexes: "",
      };
    },
    setRangeDate(eventValue) {
      this.form.start_date = eventValue ? eventValue[0] : "";
      this.form.end_date = eventValue ? eventValue[1] : "";
    },
  },
  computed: {
    formOptions: function () {
      return this.$store.state.form;
    },
    customStatusSolip: function () {
      return this.$store.state.form?.optionsStatesEmisor?.filter(
        (state) =>
          state.name !== "Error en radicación de anexo(s)" &&
          state.name !== "No aplica al radicado"
      );
    },
    customStatusSolipAnexes: function () {
      return this.$store.state.form?.optionsStatesEmisor?.filter(
        (state) =>
          state.name !== "Error en radicación" &&
          state.name !== "No aplica al radicado"
      );
    },
  },
  watch: {
    "form.motivo_emisores_id__tipo_valor_id": async function () {
      this.form.motivo_emisores_id = "";
      this.optionsReasonsEmisor = [];
      if (this.form.motivo_emisores_id__tipo_valor_id == "") {
        let options = await this.$store.dispatch(
          "form/loadAllReasonsEmisorOptions",
          { type_value_emisor: this.form.motivo_emisores_id__tipo_valor_id }
        );
        this.optionsReasonsEmisor = [...options];
        return;
      }

      let options = await this.$store.dispatch(
        "form/loadReasonsEmisorOptions",
        { type_value_emisor: this.form.motivo_emisores_id__tipo_valor_id }
      );
      this.optionsReasonsEmisor = [...options];
    },
  },
};
</script>

<style>
#filterSupportForm {
  width: 100%;
}
</style>
